<template>
  <div>
    <v-layout class="xs12 px-6 py-6">
      <v-flex class="xs12 d-flex mb-0">
        <div>
          <div class="title mb-2">Show my listing at gotpooperscooper.com directory</div>
          <div v-if="!loading">
            <span
              @click="openModal"
              style="cursor: pointer;"
              class="subheading primary--text text-uppercase"
            >{{ `${Boolean(Number(showOnList)) ? 'Yes' : 'No'}` }}
            </span>
          </div>
          <v-skeleton-loader
            v-else
            class="mt-2"
            type="heading"
            width="300px"
          ></v-skeleton-loader>
        </div>
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn 
        @click="openModal"
        sx12
        class="mr-0 mt-0"
        style="max-width: 130px;"
        color="primary" 
        dark
      >
        Edit
      </v-btn>
    </v-layout>

    <v-divider></v-divider>

    <v-dialog v-if="showDialog" v-model="showDialog" max-width="500px" persistent>
      <v-card class="pa-4">
        <v-card-title class="px-4">
            <h2 class="title">Edit show my listing at gotpooperscooper.com directory</h2>
        </v-card-title>
        <div class="pb-4 px-6">
          <v-flex class="px-1">
            <v-switch
              label="Show Listing"
              v-model="preparedData.show_on_list"
              true-value="1"
              false-value="0"
            >
            </v-switch>
          </v-flex>
          <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
            <span class="caption">{{ serverValidationMessage }}</span>
          </v-alert>
        </div>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
            <v-btn color="primary" :loading="saveLoading" :disabled="saveLoading" @click="saveChanges">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EventBus from "@/main"
import ApiService from "@/common/api.service"
import { mapGetters } from 'vuex'

export default {
  name: 'ShowOnListing',
  data() {
    return {
      no_data: [null, "", undefined, "null"],
      preparedData: {},
      saveLoading: false,
      showDialog: false,
      serverValidation: true,
      serverValidationMessage: "Oops something went wrong...",
      server_errors: {}
    }
  },
  methods: {
    openModal() {
      this.showDialog = true
      this.saveLoading = false
      this.preparedData = {
        show_on_list: this.showOnList
      }
      this.resetServerValidation();
    },
    saveChanges() {
      let body = {
        organization_settings: [
          {
            key: "show_on_list",
            value: this.preparedData.show_on_list
          },
        ]
      };
      this.saveLoading = true;
      this.resetServerValidation();

      ApiService.put("/organization_settings", body)
        .then(response => {
          this.saveLoading = false;
          EventBus.$emit("notification", {
            status: "success",
            text: "Directory Listing Settings have been successfully edited."
          });
          this.$emit('done')
          this.closeModal()
        })
        .catch(({ response }) => {
          this.saveLoading = false;
          this.serverValidation = false;
          if (response.data.error) {
            this.serverValidationMessage = this.titleCase(response.data.error);
          }
          if (response.data.message) {
            this.serverValidationMessage = response.data.message;
          }
          if (response.data.errors) {
            if (typeof response.data.errors === "string") {
              this.serverValidationMessage = response.data.errors;
            } else {
              this.server_errors = response.data.errors;
            }
          }
        });
    },
    closeModal() {
      this.showDialog = false
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
      this.server_errors = {};
    }
  },
  computed: {
    ...mapGetters({
      organizationSettings: 'organizationSettings',
      loading: 'organizationSettingsLoading'
    }),
    showOnList () {
      return !this.no_data.includes(this.organizationSettings) &&
        !this.no_data.includes(this.organizationSettings.show_on_list) ?
        this.organizationSettings.show_on_list :
        '0'
    }
  }
}
</script>